import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-link',
  imports: [NgTemplateOutlet, RouterModule, IconComponent],
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent implements OnInit, OnChanges {
  @Input() route?: string | any[];
  @Input() params?: { [key: string]: any };
  @Input() fragment?: string;
  @Input() href?: string;
  @Input() target?: '_blank' | '_self' | '_parent' | '_top';
  @Input() color: 'default' | 'primary' | 'secondary' | 'light' = 'default';
  @Input() arrow?: 'top' | 'right' | 'bottom' | 'left';
  @Input() disabled?: boolean;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  public classes: string = '';

  click(): void {
    if (this.disabled) return;
    this.clicked.emit();
  }

  setClasses(): void {
    const classes: string[] = [];
    classes.push('link');
    classes.push(`link--${this.color}`);
    if (this.disabled) classes.push('link--disabled');
    this.classes = classes.join(' ');
  }

  ngOnInit(): void {
    this.setClasses();
  }

  ngOnChanges(): void {
    this.setClasses();
  }
}
